export default function MacNotificationSettings() { return null; }
